import React from 'react';
import { Check } from 'lucide-react';

const About = ({ data }) => {
  return (
    <section className="section-padding" id="about">
      <div className="container">
        <div className="grid-two-column">
          <div>
            <h2 className="heading-1">{data.title}</h2>
            <p className="body-large" style={{ marginTop: '24px' }}>{data.bio}</p>
          </div>
          <div className="credentials-list">
            {data.credentials.map((credential, index) => (
              <div key={index} className="credential-item">
                <Check className="credential-check" />
                <span className="body-regular">{credential}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;